import {IPicture} from '@api/models/image/picture';
import {IVideo} from '@api/models/video/video';
import {TickerItemType} from '@api/models/ticker/ticker-item-type';
import {TickerItemCategory} from '@api/models/ticker/ticker-item-category';
import {TickerItemPhase} from '@api/models/ticker/ticker-item-phase';
import {IScores} from '@api/models/ticker/scores';
import {IMatchTickerItem} from '@lib-modules/match/models/match-ticker-item';

export interface ITickerItemData {
  score?: IScores;
  assist?: string;
  out_playerid?: string;
  in_playerid?: string;
}

export class TickerItem {
  _id: string;
  _created: number;
  title: string;
  automated: boolean;
  category: TickerItemCategory;
  display_minute: string;
  activation: number;
  activation_milliseconds: number;
  activation_relative_to: TickerItemPhase;
  teamid: string;
  original_text: string;
  type: TickerItemType;
  symbol: string;
  text: string | any;
  duration: number | undefined; // Only used for questions
  pictures: IPicture[];
  foes_verified?: boolean;
  data?: ITickerItemData;
  video?: {
    video_url: string;
    preview_url: string;
  };
  playerid?: string;
  videos_native: IVideo[];
  sportradar: {
    sr_action_hash: string;
    sr_action_id: number;
    sr_created: boolean;
    sr_last_update_ts: number;
    sr_verified: boolean;
  };
  timestamp: number;
  verified?: boolean;

  public static isType(item: IMatchTickerItem, type: TickerItemType): boolean {
    switch (type) {
      case TickerItemType.RedCard:
        const redCardTypes = [TickerItemType.RedCard, TickerItemType.YellowRedCard];
        return redCardTypes.includes(item.type);
      case TickerItemType.Goal:
        const goalTypes = [TickerItemType.Goal, TickerItemType.OwnGoal, TickerItemType.PenaltyGoal, TickerItemType.FreeKick];
        return goalTypes.includes(item.type);
      default:
        return item.type === type;
    }
  }

  public isType(type: TickerItemType): boolean {
    switch (type) {
      case TickerItemType.RedCard:
        const redCardTypes = [TickerItemType.RedCard, TickerItemType.YellowRedCard];
        return redCardTypes.includes(this.type);
      case TickerItemType.Goal:
        const goalTypes = [TickerItemType.Goal, TickerItemType.OwnGoal, TickerItemType.PenaltyGoal];
        return goalTypes.includes(this.type);
      default:
        return this.type === type;
    }
  }
}
